'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isHotReloading = function isHotReloading() {
  return !!(typeof module !== 'undefined' && module.hot && typeof module.hot.status === 'function' && module.hot.status() === 'apply');
};

exports.default = isHotReloading;


/*****************
 ** WEBPACK FOOTER
 ** ../~/redux-form-nullable/lib/util/isHotReloading.js
 ** module id = 566
 ** module chunks = 3
 **/